export default __webpack_public_path__ + "static/media/line.23d54d06.svg";